//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import utils from "@/utils"
import api from "@/api"
export default {
  name: 'FooterView',
  data () {
    return {
      activeStr:'UserCenter',
      num:'',
      src:'',
      urlList:[
          'http://www.sda.gov.cn',
          'http://www.cqlp.org',
          'http://zyys.sfda.gov.cn',
          'http://www.lnfda.gov.cn',
      ],
    }
  },
  created(){
      this.src = api.QRCode
    //   this.src = api.GetPayCode+'?t='+new Date().getTime()
  },
  methods:{
      spanClick () {
          window.open('http://www.beian.miit.gov.cn/')
      },
    urlClick (num) {
        window.open(this.urlList[num])
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/FooterView.vue